import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import Alert from './Alert';
import InferentialStatisticsForm from './Procedures';

import { isInferentialStatisticsCalculated } from 'store/scenes/inferentialStatistics/selectors';

const RightPanel = ({ isFrequencyOrContingency }) => {
  const showInferentialStatisticsPage = useSelector(state => isInferentialStatisticsCalculated(state));
  return (
    <>
      <Alert />
      {showInferentialStatisticsPage &&
        <InferentialStatisticsForm isFrequencyOrContingency={isFrequencyOrContingency} />
      }
    </>
  );
};

RightPanel.propTypes = {
  isFrequencyOrContingency: PropTypes.bool.isRequired
};

export default RightPanel;
